import type { ComponentOptionsMixin } from 'vue'

export interface GlobalMixins {
  isMobile: boolean
  directionClass: string
  isRtl: boolean
}

const globalMixins: ComponentOptionsMixin = {
  computed: {
    isMobile(): boolean {
      return this.$vuetify.display.mobile
    },
    directionClass(): string {
      return this.isRtl ? 'rtl' : 'ltr'
    },
    isRtl(): boolean {
      return this.$vuetify.locale.isRtl
    },
  },
}
export default globalMixins
